import instance from './instance';

export const fetchMeetingMode = uuid => instance.get(`/workspaces/${uuid}/status_meeting_mode`);

export const startMeetingMode = uuid => instance.put(`/workspaces/${uuid}/start_meeting_mode`);

export const leaveMeetingMode = uuid => instance.put(`/workspaces/${uuid}/leave_meeting_mode`);

export const updateMeetingMode = (uuid, params) => instance.put(`/workspaces/${uuid}/update_meeting_mode`, params);

export const updateMeetingModeV2 = (uuid, data) => instance.put(`/workspaces/${uuid}/update_meeting_mode_v2`, data);
